<svelte:options accessors immutable={true}/>
<script>
    import moment from 'moment';
    
    export let content;
    export let categories;
    export let products;
</script>

<div class="wide-block" style="height: calc(100vh - 50px); overflow-y: scroll; padding-left: 0; padding-right: 0;">
    <ul class="nav nav-tabs capsuled" role="tablist">
        <li class="nav-item">
            <a class="nav-link active" data-bs-toggle="tab" href="#preview" role="tab">
                Предпросмотр
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" href="#categories" role="tab">
                <div style="margin-right: 5px;">Категории</div>
                <div class="badge badge-primary ml-3">{categories.length}</div>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" href="#products" role="tab">
                <div style="margin-right: 5px;">Продукты</div>
                <span class="badge badge-primary">{products.length}</span>
            </a>
        </li>
    </ul>
    
    <div class="tab-content">
        <div class="tab-pane fade active show" id="preview" role="tabpanel">
            <iframe class="{!content ? 'd-none' : ''}" referrerpolicy="no-referrer" style="height: calc(-95px + 100vh); width: 100%;"></iframe>
        
            {#if !content }
                <div class="row my-5">
                    <div class="col-12 text-center">
                        Предпросмотр недоступен
                    </div>
                </div>
            {/if}
        </div>
        <div class="tab-pane fade" id="categories" role="tabpanel">
            {#if categories.length}
                <ul class="listview image-listview" style="background-color: transparent">
                    {#each categories as item}
                        <li>
                            <div class="item">
                                <img src="{item.image ? item.image : '/no_image.svg'}" alt="{item.title}" class="image">
                                <div class="in">
                                    <div>
                                        <header>[{item.index}:{item.parent}] {item.title}</header>
                                        <span class="text-small">{item.description}</span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    {/each}
                </ul>
            {:else}
                <div class="row my-5">
                    <div class="col-12 text-center">
                        Список категорий - пуст
                    </div>
                </div>
            {/if}
        </div>
        <div class="tab-pane fade" id="products" role="tabpanel">
            {#if products.length}
                <ul class="listview image-listview" style="background-color: transparent">
                    {#each products as item}
                        <li>
                            <div class="item">
                                <img src="{item.image ? item.image : '/no_image.svg'}" alt="{item.title}" class="image">
                                <div class="in">
                                    <div>
                                        <header>[{item.index}:{item.parent}] {item.title}</header>
                                        <span class="text-small">{item.price}</span>
                                        <span class="text-small">{item.vendorcode}</span>
                                        <span class="text-small">{item.description}</span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    {/each}
                </ul>
            {:else}
                <div class="row my-5">
                    <div class="col-12 text-center">
                        Список продуктов - пуст
                    </div>
                </div>
            {/if}
        </div>
    </div>
    
    {#if !content}
        <div class="appFooter">
            <div class="footer-title">
                Copyright © <a href="https://alksily.getwebspace.org" target="_blank">Aleksey Ilyin</a>
                <span class="yearNow">{moment().year()}</span>. All Rights Reserved.
            </div>
        </div>
    {/if}
</div>
